<template>
  <b-modal
    id="errorModal"
    ref="errorModal"
    :title="$t('error_modal_title')"
    title-tag="h3"
    centered
    lazy
    ok-only
    ok-variant="danger"
    :ok-title="$t('close')"
    header-bg-variant="danger"
    header-text-variant="light"
    >
    <p class="text-danger">{{message}}</p>
  </b-modal>
</template>

<script>
export default {
  props: {
    message: {
      type: [String, Object],
      required: true
    }
  },
  methods: {
    ok (bvEvt) {
      bvEvt.preventDefault()
      this.$refs.deleteModal.hide()
    }
  }
}
</script>
